import React from 'react';

import { AdapterDateFns } from '../AdapterDateFns';
import { DatePicker } from '../DatePicker';
import { LocalizationProvider } from '../LocalizationProvider';
import { FormControl, FormHelperText } from '../Form';

function DatePickerField(props) {
  const {
    input: {
      name,
      value,
      onChange,
      ...restInput
    },
    helperText,
    meta: { touched, error },
    required,
    label,
    fullWidth,
    color = 'primary',
    variant,
    ...custom
  } = props;

  const hasError = Boolean(touched && error);

  const handleDateChange = (date) => {
    onChange(date?.toJSON());
  };

  return (
    <FormControl
      required={required}
      variant={variant}
      color={color}
      style={{ width: (fullWidth ? '100%' : undefined) }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          variant='inline'
          format='MM/dd/yyyy'
          margin='normal'
          label={label}
          value={value}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          slotProps={{
            textField: {
              name,
              variant: 'outlined',
              error: hasError,
              helperText: hasError ? error : helperText,
              FormHelperTextProps: { component: FormHelperText, error: hasError },
              ...restInput,
            },
          }}
          color={color}
          {...custom}
        />
      </LocalizationProvider>
    </FormControl>
  );
}

export default DatePickerField;
